import i18next from 'i18next';
import I18NextVue from 'i18next-vue';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-locize-backend';
import type { App } from 'vue';

const locizeOptions = {
    projectId: 'fb316993-6497-4bbe-a193-f45a79e2d614',
    apiKey: '5a87f465-5ab9-4dca-a198-b90c0ada5726', // YOU should not expose your apps API key to production!!!
    version: 'latest',
    selectorAttr: 'data-i18n',
    allowedAddOrUpdateHosts: ['managerdummy.eqtiming.com'],
};

export const i18nextPromise = i18next
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        backend: locizeOptions,
        ns: ['manager'],
        defaultNS: 'manager',
        load: 'currentOnly',
        debug: false,
        saveMissing: true,
        fallbackLng: 'en',
    });

export default function (app: App<Element>) {
    app.use(I18NextVue, { i18next });
    return app;
}
